// extracted by mini-css-extract-plugin
export var root = "_5Ds8";
export var rootList = "DiOV";
export var rootListItem = "siPz";
export var rootListItemButtonPrimary = "nUKL";
export var rootListItemButtonSecondary = "W20k";
export var rootListItemFooterLink = "kxsf";
export var rootListItemHiddenDesktop = "SLDH";
export var rootListItemHiddenMobile = "cvkI";
export var rootListItemLabel = "jQEf";
export var rootListItemLabelIcon = "_5haA";
export var rootListItemMegaMenu = "CFw9";
export var rootListItemMobileCategories = "_74K9";
export var rootListItemOrange = "Ueed";
export var rootListItemRed = "_5VND";
export var rootMobileCategoriesGrid = "i+q5";
export var rootMobileCategoryCard = "_6-R0";
export var rootMobileCategoryImage = "KN5L";
export var rootMobileCategoryImageWrapper = "s2VW";
export var rootMobileCategoryLabel = "MHdd";
export var rootMobileOpened = "kWaz";
export var rootOverflowHidden = "RZLQ";
export var rootSearching = "IEaH";